module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Capitolo due")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quel compito sarebbe toccato alla gendarmeria locale, guidata dal sergente Winston Windflower della RCMP, la Polizia Reale Canadese a cavallo. Windflower era un autoctono, un "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cree")]), _vm._v(" purosangue della Riserva di Pink Lake nel nord dell'Alberta e si trovava a Grand Bank su incarico da poco più di un anno. Era preoccupato per il fatto di dover gestire suo primo grande caso in questa piccola comunità di Terranova, ma sicuramente gli sembrava una gradita pausa dall'inseguimento di adolescenti che avevano preso a bere birra sotto il molo tutte le calde notti di primavera ed estate.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Quindi da dove cominciamo, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sarge")]), _vm._v("?» domandò l'agente Eddie Tizzard. Tizzard, il ragazzo del posto che aveva fatto carriera, era entusiasta dell'opportunità di mostrare ai cittadini che oltre alla splendente serge rossa e ai lucidi stivali marroni aveva anche altre qualità.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Facile, agente. Dobbiamo assicurarci di fare un buon lavoro. Partiamo dall’inizio. Parliamo con i turisti che hanno trovato il sig. Martin e poi passiamo dal dott. Sanjay alla clinica. Se si fosse trattato di un attacco di cuore o di un ictus dovrebbe essere in grado di confermarcelo, e potremo già chiudere il caso entro l'ora di pranzo».")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tizzard quasi disse “speriamo di no”, ma a giudicare dallo sguardo severo sul volto del sergente riformulò la sua strategia ed esclamò semplicemente «Certo boss», quindi afferrò il cappello e uscì dalla porta.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Anche Windflower non era sicuro che si trattasse di un attacco cardiaco. Qualcosa gli rodeva le viscere e gli diceva che c'era dell'altro in quella storia oltre a una banale insufficienza coronarica. Ma tenne per sé quell'idea e lasciando l'ufficio annuì semplicemente al suo impaziente subalterno. Decise di andare dalla miglior fonte di informazioni ufficiose, il Mug-Up Café, per una tazza di tè nero forte e per curiosare in giro.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Buongiorno Sheila», esclamò mentre osservava la proprietaria della caffetteria impegnata nel mantenere in equilibrio tre tazze di caffè e svariate porzioni di spesso pane tostato fatto in casa.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Buongiorno sergente», sorrise Sheila, in parte per lo sforzo dato dal carico ma più per la vista dell'affascinante giovane Mountie"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(". Deve avere a che fare con gli uomini in uniforme,")]), _vm._v(" pensò.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Una tazza di tè quando puoi», disse, restituendole il sorriso. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Molto piacevole")]), _vm._v(", pensò tra sé, e poi altrettanto rapidamente si ricompose nella sua maschera ufficiale di determinazione. Non era il momento di dare agli avventori abituali alcun motivo di dubitare della sua professionalità.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Windflower si sistemò in un tavolino vicino al bancone, un ottimo posto per osservare tutti quelli che andavano e venivano, ma soprattutto il posto migliore per origliare discretamente le conversazioni sommesse che si svolgevano in ogni angolo del locale. Tutti lo avevano visto entrare, ma lui aveva imparato che il bisogno fondamentale di pettegolezzi delle persone supera quasi tutte le altre emozioni, soprattutto se hanno una notizia succosa da condividere con i compagni di chiacchiere. Sheila gli aveva appena portato una fumante tazza di tè con strizzatina d’occhio annessa.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tutti i presenti si voltarono simultaneamente verso di lui mentre chiedeva alla proprietaria della caffetteria se poteva utilizzare il piccolo ufficio sul retro per rispondere.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }), _c('p', {
    staticClass: "blockquote",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Certo, sergente, qualunque cosa per i Mountie», esclamò Sheila raggiante.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Windflower corse sul retro e parlò al suo agente. «Che succede, Tizzard?»")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "18",
      "src": "d2d_images/image051.png",
      "width": "23"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("«Sergente, penso che dovrebbe venire alla clinica e sentire cosa ha da dirle il dottore in persona», esclamò l’agente.")])]), _vm._v(" "), _c('div', {
    staticClass: "poetry"
  }, [_c('p', {
    staticClass: "poetry"
  }, [_vm._v("«Resta lì, Tizzard, sto arrivando», rispose Windflower.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0